// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3LIBY","title":"Header_title__3ev4C","left":"Header_left__2Joyn","clinicName":"Header_clinicName__H0OQk"};